import React from 'react';
import about from '../images/about.jpg'
import code from '../images/code.png'
const About = () => {
    return (
        <div className="hero min-h-screen " id='about'>
                <div className="hero-content flex-col lg:flex-row-reverse ">

                    <div data-aos="fade-left" className='basis-1/2 lg:ml-20'>

                        <h1 className="text-3xl my-5 text-white ">About ME </h1>
                        <img src={code} alt=""  />
                        <div className='my-5 flex '>
                            <div className='text-lg font-bold text-white grid gap-4 pr-5'>
                                <h1>Name</h1>
                                <h1>Experience</h1>
                                <h1>Age</h1>
                                <h1>Email</h1>
                                <h1>Address</h1>
                                <h1>Phone</h1>
                            </div>
                            <div className='text-xl grid gap-4  text-white'>
                                <h1>: Najmul Hossain</h1>
                                <h1>: 06+ Mounths</h1>
                                <h1>: 23</h1>
                                <h1>: najmul.tk16@gmail.com</h1>
                                <h1>: Pallabi,Mirpur Dhaka</h1>
                                <h1>: +8801878538321</h1>
                            </div>
                        </div>
                        
                    </div>
                    <img data-aos="fade-right" src={about} className="max-w-sm border-4 border-neutral basis-1/2 profile" alt='' />
                </div>
                
            </div>
    );
};

export default About;



